import { types as ActionTypes } from './DataMap.actions';
import AuthenticatedPaths from '/b2b/routing/AuthenticatedRoutes/AuthenticatedRoutes.paths';
import { MAP_FILTERS } from '../constants';
import { types as NavActionTypes } from '/b2b/common/state/nav/Nav.actions';
import { genericReducer } from '/b2b/common/helpers/ReduxHelpers';
import { matchPath } from 'react-router-dom';
import reduceReducers from 'reduce-reducers';

const initialFilters = {
    ...Object.keys(MAP_FILTERS).reduce(
        (acc, key) => ({
            ...acc,
            [key]: [],
        }),
        {}
    ),
};

export const initialState = {
    direction: null,
    filters: { ...initialFilters },
    fullscreen: false,
    layoutComplete: false,
    loading: true,
    nodesToConnect: {},
    savingNodeId: null,
    selectedFilters: { ...initialFilters },
    unmappedNodes: [],
};

export default reduceReducers(
    initialState,
    genericReducer(initialState, {
        [NavActionTypes.routeChanged]: (state, payload) => {
            const { location } = payload;
            const match = matchPath(location.pathname, `${AuthenticatedPaths.DATA_MAP}`);
            if (!match) {
                return initialState;
            }
            return state;
        },
        [ActionTypes.setDirection]: (state, direction) => ({
            ...state,
            direction,
        }),
        [ActionTypes.setFilters]: (state, filters = {}) => ({
            ...state,
            filters: {
                ...state.filters,
                ...filters,
            },
        }),
        [ActionTypes.setFullscreen]: (state, fullscreen) => ({
            ...state,
            fullscreen,
        }),
        [ActionTypes.setLayoutComplete]: (state, layoutComplete) => ({
            ...state,
            layoutComplete,
        }),
        [ActionTypes.setLoading]: (state, loading) => ({
            ...state,
            loading,
        }),
        [ActionTypes.setNodesToConnect]: (state, nodesToConnect) => ({
            ...state,
            nodesToConnect,
        }),
        [ActionTypes.setSavingNodeId]: (state, savingNodeId) => ({
            ...state,
            savingNodeId,
        }),
        [ActionTypes.setSelectedFilters]: (state, selectedFilters = {}) => ({
            ...state,
            selectedFilters: {
                ...state.selectedFilters,
                ...selectedFilters,
            },
        }),
        [ActionTypes.setUnmappedNodes]: (state, unmappedNodes = []) => ({
            ...state,
            unmappedNodes,
        }),
    })
);
